import React, { useEffect, useState } from "react";
import ReservationModal from "./ui/ReservationModal";
import { getConversionState } from "../../lib/conversionState";

/**
 * Lightweight, invisible host that owns the Personal Action Plan Stripe
 * checkout modal at the App-shell level. Mirrors
 * <BookCheckoutHost>. When a visitor already has a saved
 * blueprint draft, we route them to /blueprint/intake (their
 * resumed flow) instead of re-charging them — same behavior the
 * old in-section listener had, preserved here so dispatchers
 * elsewhere on the site keep working without a visible Personal Action Plan
 * section on the homepage.
 */
const BlueprintCheckoutHost = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => {
      const conv = getConversionState();
      // Mirror the old in-section behavior: if the visitor already has
      // a saved Personal Action Plan draft, drop them back into the intake flow
      // (where the draft is restored) instead of opening a fresh
      // checkout modal. Re-charging would be wrong.
      if (conv && conv.blueprintStarted && !conv.blueprintSubmitted) {
        window.location.href = "/blueprint/intake";
        return;
      }
      setOpen(true);
    };
    window.addEventListener("am:open-blueprint-checkout", handler);
    return () => window.removeEventListener("am:open-blueprint-checkout", handler);
  }, []);

  return (
    <ReservationModal
      open={open}
      onClose={() => setOpen(false)}
      product="blueprint"
      testIdPrefix="blueprint"
      eyebrow="Begin the Alignment"
      title="You have just stopped blocking it."
      description="Secure checkout via Stripe. You will be redirected to complete your Momentum Personal Action Plan purchase."
      submitLabel="Start My Personal Action Plan · $49.99"
      busyLabel="Opening your Personal Action Plan checkout…"
    />
  );
};

export default BlueprintCheckoutHost;
